import { refreshTokenHandler, setLocaleHeader } from '@brightdrop/auth-client';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const assetsInitialApi = createApi({
  reducerPath: 'rtkAssetsClient',
  refetchOnMountOrArgChange: 10,
  baseQuery: fetchBaseQuery({
    baseUrl: `${globalThis.appConfig.apiBaseUrl}/assets`,
    prepareHeaders: async (headers) => {
      const response = await refreshTokenHandler();
      const { accessToken: token } = response ?? {};

      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      if (!headers.has('Accept')) {
        headers.set('Accept', 'application/json, text/plain, */*');
      }
      // Intentionally no Content-Type default. fetchBaseQuery detects
      // jsonifiable bodies (plain objects, arrays, anything with `.toJSON()`),
      // sets `application/json`, and stringifies them. Forcing it here would
      // override the multipart boundary on FormData uploads.
      setLocaleHeader(headers);

      return headers;
    },
  }),
  endpoints: () => ({}),
});
